export default __webpack_public_path__ + "53ae786eb97c91f6e56cf4c3f053fe03.png";